<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
document.title = "慧小娱IOT设备管理平台";
</script>


